import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import EnrollModal from "../components/EnrollModal";
import "../styles/CourseDetail.css";

const courseData = {
  "classrooms": {
    
    title: "Tutions",
    description:
      "Experience immersive classroom learning guided by expert faculty for stronger concepts, discipline, and consistent academic success.",
    features: [
      "Highly experienced faculty",
      "Interactive doubt-clearing sessions",
      "Structured classroom teaching",
      "Comprehensive printed study material",
      "Regular mock tests & detailed performance analysis",
      "Personal attention to every student",
      "Exam-oriented teaching methodology",
      "Daily practice problems (DPPs)",
      "Motivational mentoring & guidance",
      "Focused preparation for board & competitive exams"
    ]
  },
  "stay": {
    title: "Stay and Study",
    description:
      "Live, study, and succeed in a disciplined campus environment designed for academic excellence.",
    features: [
      "Safe, comfortable on-campus hostel accommodation",
      "Distraction-free study environment with fixed study hours",
      "Daily access to faculty support and mentoring",
      "Structured routine for classes, self-study, and revision",
      "Regular tests, evaluations, and performance tracking",
      "Peer learning with a motivated academic community",
      "Healthy meals and basic facilities for student well-being",
      "Secure campus with supervision and care"
    ]
  },
  "self-study": {
    title: "Self Study",
    description:
      "Ideal for independent learners who want flexibility while following a structured, result-oriented study approach.",
    features: [
      "Concept-based video lessons",
      "Writing notes",
      "Chapter-wise practice questions",
      "Step-by-step solution videos",
      "Self-paced revision modules",
      "Regular self-assessment tests",
      "Performance tracking & progress insights",
      "Repeat lessons anytime for clarity",
      "Exam-focused practice routines",
      "24/7 access from any device"
    ] 
  },
  "tests-series": {
    title: "Test Series",
    description:
      "Sharpen your exam readiness with real-time exam simulations and in-depth performance insights.",
    features: [
      "Full-length exam pattern tests",
      "Chapter-wise & subject-wise tests",
      "Detailed step-by-step solutions",
      "Time management practice",
      "Strength & weakness analysis",
      "Performance comparison with toppers",
      "Previous year question-based tests",
      "Exam-level difficulty simulation"
    ]
  }
};

function CourseDetail() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const course = courseData[courseId];

  const [open, setOpen] = useState(false);

  if (!course) {
    return <h2>Course Not Found</h2>;
  }

  return (
    <>
      <div className="course-detail">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1>{course.title}</h1>
        <p className="course-desc">{course.description}</p>

        <h3>What you’ll get</h3>
        <ul>
          {course.features.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <button className="enroll-btn" onClick={() => setOpen(true)}>
          Enroll Now
        </button>
      </div>

      {/* ENROLL MODAL */}
      <EnrollModal
        isOpen={open}
        onClose={() => setOpen(false)}
        courseName={course.title}
      />
    </>
  );
}

export default CourseDetail;
